import moment from "moment";

const shortDay = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

export default (day: number) => {
  return `${shortDay[day]}`;
};
